import { useContext, Fragment } from 'react';

import { useHistory } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Button,
  Typography,
  useMediaQuery
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';

import { useStyles } from './navbar.styles';
import { SessionContext } from '../../context/session.context';
import { has } from '../../services/summarize.service';
import { logout } from '../../services/auth.service';

export const NavbarComponent = () => {

  const history = useHistory();
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const { logged, handleSession } = useContext(SessionContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const redirect = (route) => {
    history.push(route);
  }

  const doLogout = async () => {
    await logout();
    handleSession({
      userObject: null,
      logged: false,
      user: null
    });
    enqueueSnackbar('Sesión cerrada correctamente', {
      variant: 'success',
      resumeHideDuration: 3000,
      anchorOrigin:
        { horizontal: 'right', vertical: 'bottom' }
    });
    redirect('/');
  }

  return (
    <AppBar position="static" className={classes.appBar} id="navbar-frida">
      <Toolbar>
        <Typography variant="h6" className={classes.title} onClick={() => redirect('/main')}>
          Frida
        </Typography>
        {logged ? (
          <Fragment>
            <Button color="inherit" onClick={() => redirect('/carta')}>Carta</Button>
            {!isMobile && has('USERS::LIST') && (
              <Button color="inherit" onClick={() => redirect('/users')}>Usuarios</Button>
            )}
            {!isMobile && has('CATEGORIES::LIST') && (
              <Button color="inherit" onClick={() => redirect('/categories')}>Categorias</Button>
            )}
            {!isMobile && has('PRODUCTS::LIST') && (
              <Button color="inherit" onClick={() => redirect('/products')}>Productos</Button>
            )}
            {!isMobile && has('EXPENSES::LIST') && (
              <Button color="inherit" onClick={() => redirect('/expenses')}>Gastos</Button>
            )}
            {!isMobile && has('CUTOFF::LIST') && (
              <Button color="inherit" onClick={() => redirect('/cutoff')}>Corte</Button>
            )}
            {has('SALES::LIST') && (
              <Button color="inherit" onClick={() => redirect('/sales')}>Ventas</Button>
            )}
            <Button color="inherit" onClick={doLogout}>Cerrar Sesión</Button>
          </Fragment>
        ) : (
          <Fragment>
            <Button color="inherit">Ingresar</Button>
          </Fragment>
        )}
      </Toolbar>
    </AppBar>
  );
}